import { useTheme } from '../contexts/ThemeContext';

export const useThemeClasses = () => {
  const { isModern } = useTheme();
  
  console.log('🎨 useThemeClasses called - isModern:', isModern);

  return {
    isModern,
    // Modal styles
    modal: {
      container: isModern 
        ? "bg-white rounded-xl shadow-2xl" 
        : "bg-white rounded-lg shadow-lg",
      header: isModern 
        ? "bg-gradient-to-r from-primary-600 to-primary-700 text-white px-4 py-3" 
        : "bg-gray-50 border-b border-gray-200 px-4 py-3",
      headerText: isModern 
        ? "text-white" 
        : "text-gray-900",
      footer: isModern 
        ? "border-t border-gray-200 p-4 bg-gray-50" 
        : "border-t border-gray-200 p-4 bg-white"
    },
    
    // Button styles
    button: {
      primary: isModern 
        ? "bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-medium px-4 py-2 rounded-lg shadow-md transition-all duration-200" 
        : "bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded border transition-colors",
      secondary: isModern 
        ? "bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium px-4 py-2 rounded-lg transition-all duration-200" 
        : "bg-white hover:bg-gray-50 text-gray-700 font-medium px-4 py-2 rounded border border-gray-300 transition-colors"
    },
    
    // Card styles
    card: isModern 
      ? "bg-white rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300" 
      : "bg-white rounded border border-gray-200 hover:shadow-md transition-shadow",
    
    // Tab styles
    tabs: {
      container: isModern 
        ? "border-b border-gray-200 bg-gray-50" 
        : "border-b border-gray-300 bg-white",
      active: isModern 
        ? "border-b-2 border-primary-600 text-primary-600 bg-white" 
        : "border-b-2 border-blue-600 text-blue-600 bg-gray-50",
      inactive: isModern 
        ? "text-gray-600 hover:text-gray-900 hover:bg-gray-100" 
        : "text-gray-500 hover:text-gray-700 hover:bg-gray-100"
    }
  };
};